/**
 * Web ad service — banner ads use AdSense (see AdBanner.web.tsx).
 * Full-screen interstitials are native-only (AdMob).
 */
class AdService {
  loadInterstitialAd(): void {}

  canShowInterstitialAd(): boolean {
    return false;
  }

  showInterstitialAd(): Promise<boolean> {
    return Promise.resolve(false);
  }

  loadRewardedAd(): void {}

  showRewardedAd(): Promise<{ type: string; amount: number } | null> {
    return Promise.resolve(null);
  }

  loadRewardedInterstitialAd(): void {}

  showRewardedInterstitialAd(): Promise<{ type: string; amount: number } | null> {
    return Promise.resolve(null);
  }

  isInterstitialReady(): boolean {
    return false;
  }

  isRewardedReady(): boolean {
    return false;
  }

  isRewardedInterstitialReady(): boolean {
    return false;
  }
}

export const adService = new AdService();
